import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AppShell } from "../components/AppShell";

export const Route = createFileRoute("/hosts")({
  component: HostsLayout,
});

function HostsLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
